
  import React from "react"
  import Component from "/Users/jurre/Sites/patronenvanbedrog/src/layouts/index.js"
  import data from "/Users/jurre/Sites/patronenvanbedrog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js